(() => {
  if (customElements.get('dyefor-case-feature-grid')) return;

  class DyeforCaseFeatureGrid extends HTMLElement {
    connectedCallback() {
      this.productRoot = this.closest('[id^="MainProduct-"]');
      this.onVariantChange = (event) => this.updateFromVariant(event.detail);
      document.addEventListener('variantchanged', this.onVariantChange);
      this.updateFromVariant(this.productRoot?.querySelector('variant-selects, variant-radios')?.currentVariant);
    }

    disconnectedCallback() {
      document.removeEventListener('variantchanged', this.onVariantChange);
    }

    updateFromVariant(variant) {
      const selectedId = this.productRoot?.querySelector('product-form form [name="id"]')?.value;
      if (!variant || String(variant.id) !== selectedId) return;
      this.updateFeatures(variant.options || [variant.option1, variant.option2, variant.option3]);
    }

    updateFeatures(options) {
      const values = options.filter(Boolean).join(' ').toLowerCase();
      let profile = 'unknown';
      let protection = 'Made-to-order case';
      let construction = 'Designed for your phone';
      if (values.includes('impact')) {
        profile = 'impact';
        protection = 'Shock-absorbing edges';
        construction = 'Raised screen & camera edges';
      } else if (values.includes('tough')) {
        profile = 'tough';
        protection = values.includes('clear edges') ? 'Shock-absorbing edges' : 'Dual-layer protection';
        construction = values.includes('clear edges') ? 'Raised screen & camera edges' : 'Designed for your phone';
        if (values.includes('printed edges')) construction = 'Wraparound printed design';
      } else if (values.includes('snap')) {
        profile = 'snap';
        protection = 'Lightweight slim shell';
        construction = values.includes('printed edges') ? 'Wraparound printed design' : 'Back & side coverage';
      }
      this.dataset.profile = profile;
      this.hidden = profile === 'unknown';
      this.querySelector('[data-case-protection]').textContent = protection;
      this.querySelector('[data-case-construction]').textContent = construction;
    }
  }

  customElements.define('dyefor-case-feature-grid', DyeforCaseFeatureGrid);
})();
